import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
/**
 * Generated class for the ShiftonmapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

declare var google;

@Component({
  selector: 'page-shiftonmap',
  templateUrl: 'shiftonmap.html',
})
export class ShiftonmapPage {
  @ViewChild('mapFull') mapElement: ElementRef;
  typeact = ''
  desc = ''
  driver = ''
  startdt: any
  enddt: any
  startlat: any
  startlng: any
  endlat: any
  endlng: any
  Map: any
  breaktype = -1
  desc1 = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.typeact = this.gn.decrypt(navParams.get('typeact'))
    this.desc = this.gn.decrypt(navParams.get('desc'))
    this.driver = this.gn.decrypt(navParams.get('driver'))
    this.startdt = this.gn.decrypt(navParams.get('startdt'))
    this.enddt = this.gn.decrypt(navParams.get('enddt'))
    this.startlat = this.gn.decrypt(navParams.get('startlat'))
    this.startlng = this.gn.decrypt(navParams.get('startlng'))
    this.endlat = this.gn.decrypt(navParams.get('endlat'))
    this.endlng = this.gn.decrypt(navParams.get('endlng'))
    this.breaktype = parseInt(this.gn.decrypt(navParams.get('breaktype')))
    this.desc1 = this.gn.decrypt(navParams.get('desc1'))
  }

  ionViewDidLoad() {
    this.initMap()
  }


  initMap() {
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
    }
    this.Map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('rep map') }, function () {
    })

    var img = ''
    if (this.typeact + '' == '0') {
      img = 'assets/imgs/newpin-green2.png'
    }
    if (this.typeact + '' == '1') {
      if (this.breaktype + '' == '1') {
        img = 'assets/imgs/newpin-blue.png'
      }
      if (this.breaktype + '' == '2') {
        img = 'assets/imgs/newpin-olive.png'
      }
      if (this.breaktype + '' == '3') {
        img = 'assets/imgs/newpin-orange.png'
      }
    }
    if (this.typeact + '' == '2') {
      img = 'assets/imgs/newpin-red.png'
    }

    var markerIcon = {
      url: img,
      scaledSize: new google.maps.Size(38, 43),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(13, 43),
      labelOrigin: new google.maps.Point(13, 13)
    };

    var myLatLng = { lat: parseFloat(this.startlat), lng: parseFloat(this.startlng) };
    /*done*/var marker = new google.maps.Marker({
      icon: markerIcon,
      position: myLatLng,
      map: this.Map,
      // title: this.Data.name
    });
    this.Map.setCenter(myLatLng)


    if (this.typeact + '' == '1') {
      var myLatLng1 = { lat: parseFloat(this.endlat), lng: parseFloat(this.endlng) };
      /*done*/var marker1 = new google.maps.Marker({
        icon: markerIcon,
        position: myLatLng1,
        map: this.Map,
        // title: this.Data.name
      });
      this.Map.setCenter(myLatLng1)
    }

    var _content = ``
    if (this.typeact + '' == '1') {
      var bounds = new google.maps.LatLngBounds();
      var latLng = new google.maps.LatLng(this.startlat, this.startlng);
      bounds.extend(latLng);
      latLng = new google.maps.LatLng(this.endlat, this.endlng);
      bounds.extend(latLng);
      this.Map.fitBounds(bounds);

      _content = `
        <div class="mapwindow-text">`+ this.dic.l["start"] + `: <b>` + this.startdt + `</b></div>
      `
      var infowindow = new google.maps.InfoWindow({
        content: _content
      });
      infowindow.open(this.Map, marker);


      var _content1 = ``
      _content1 = `
        <div class="mapwindow-text">`+ this.dic.l["end"] + `: <b>` + this.enddt + `</b></div>
      `
      var infowindow1 = new google.maps.InfoWindow({
        content: _content1
      });
      infowindow1.open(this.Map, marker1);

    } else {
      _content = `
        <div class="mapwindow-text">`+ this.dic.l["Time"] + `: <b>` + this.startdt + `</b></div>
      `
      var infowindow = new google.maps.InfoWindow({
        content: _content
      });
      infowindow.open(this.Map, marker);
    }
  }

}



/*

datetime: "2018-05-30T08:37:06.601Z"

latitude: "41.860331"

longitude: "20.927794"

speed: "120.240000"

vehicleid: 2962

*/


// WEBPACK FOOTER //
// ./src/pages/reports/shiftonmap/shiftonmap.ts